import { getCookies } from "@/helpers/cookie";
import { atom } from "jotai";
import { expensesAtom } from "./global";

export const updateExpenseIdAtom = atom<string | null>(null);
updateExpenseIdAtom.debugLabel = "updateExpenseIdAtom";

export const hasExpensesAtom = atom<boolean>((get) => {
  const expenses = get(expensesAtom);

  return getCookies().get("has-expenses") === "1" || expenses.expenses.length > 0;
});
